module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Head-fmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Thank you to Rose, my wonderful editor, for indulging me in my passion on this one. Thanks to Emily, my fabulous agent, who is always there for me.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("As always, thanks to Mark, Matt, and Jason for your love and encouragement.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("A special thank-you to the wonderful Amy Milder of Literary Lacquers for bringing my vision of the nail polish collection in this book to life.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("You can learn more about Amy and her lovely nail polishes at: "), _c('a', {
    attrs: {
      "href": "http://www.etsy.com/shop/LiteraryLacquer",
      "target": "_blank"
    }
  }, [_vm._v("www.etsy.com/shop/LiteraryLacquer")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("For details about the nail polish collection, check Amy’s shop or go to "), _c('a', {
    attrs: {
      "href": "http://www.OpalCarew.com/Nailed",
      "target": "_blank"
    }
  }, [_vm._v("www.OpalCarew.com/Nailed")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2129ca1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 72
// module chunks = 0